import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";
import * as types from "@/store/constants/types";
import loadingAnimaton from "@/components/loadingAnimaton/loadingAnimaton.vue";
import VipBotton from "./tostButton.vue";
import EventBus from "@/utils/eventBus";
import { getLang } from '@/api/utils/apiHelper';

var VipToast =
/*#__PURE__*/
function (_Vue) {
  _inherits(VipToast, _Vue);

  function VipToast() {
    var _this;

    _classCallCheck(this, VipToast);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VipToast).apply(this, arguments));
    _this.aniOn = false;
    _this.contentBoxWidth = 0;
    _this.contentBoxHeight = 0;
    _this.contentBorderWidth = 16;
    _this.contentBoxD = "";
    _this.contentSvgAnimateStyle = {};
    _this.showCloseBtnTime = 5;
    _this.showCloseBtnLater = false;
    _this.allHeight = 432;
    _this.remainTopRadio = 68 / (167 + 68);
    _this.isShow = false;
    _this.toastData = {};
    _this.countDownTime = "00:00:00";
    return _this;
  }

  _createClass(VipToast, [{
    key: "refreshTime",
    value: function refreshTime(timestamp) {
      var nowTime = new Date().valueOf();
      var endTime = timestamp;
      var t = endTime - nowTime;

      if (t <= 0) {
        this.cancelFn && this.cancelFn();
        clearTimeout(this.countDownTimer);
      }

      var hour = Math.floor(t / 1000 / 60 / 60 % 24);
      var min = Math.floor(t / 1000 / 60 % 60);
      var sec = Math.floor(t / 1000 % 60);

      if (hour < 10) {
        hour = "0" + hour;
      }

      if (min < 10) {
        min = "0" + min;
      }

      if (sec < 10) {
        sec = "0" + sec;
      }

      this.countDownTime = hour + ":" + min + ":" + sec;
    }
  }, {
    key: "getCountDown",
    value: function getCountDown(timestamp) {
      var _this2 = this;

      clearTimeout(this.countDownTimer);
      this.refreshTime(timestamp); //先显示

      this.countDownTimer = setInterval(function () {
        _this2.refreshTime(timestamp);
      }, 1000);
    }
  }, {
    key: "hideToast",
    value: function hideToast() {
      EventBus.$emit("vip-toast-show", {
        show: false
      });
    }
  }, {
    key: "clickConfirm",
    value: function clickConfirm() {
      this.confirmFn && this.confirmFn();
      !this.confirmNotClose && this.hideToast();
    }
  }, {
    key: "clickMask",
    value: function clickMask() {}
  }, {
    key: "clickAllBtn",
    value: function clickAllBtn() {
      this.clickConfirm();
    }
  }, {
    key: "initFuseAnimate",
    value: function initFuseAnimate() {
      var _this3 = this;

      var loadImg = document.getElementById("load-img");
      var timer = setInterval(function () {
        if (document.getElementById("load-img") && document.getElementById("load-img").complete) {
          clearInterval(timer);
          var wrappeDom = document.getElementById("content-box");
          console.log("wrappeDom:", wrappeDom);
          _this3.contentBoxWidth = wrappeDom.clientWidth + _this3.contentBorderWidth;
          _this3.contentBoxHeight = wrappeDom.clientHeight + _this3.contentBorderWidth;
          console.log("this.contentBoxWidth:", wrappeDom.clientWidth, wrappeDom.clientHeight); //draw line

          _this3.contentBoxD = "\n          M".concat(_this3.contentBoxWidth / 2, " 0 L").concat(_this3.contentBoxWidth, " 0 L").concat(_this3.contentBoxWidth, " ").concat(_this3.contentBoxHeight, " L0 ").concat(_this3.contentBoxHeight, " L0 0 L").concat(_this3.contentBoxWidth / 2, " 0\n        "); //draw dash

          _this3.contentSvgAnimateStyle = {
            "stroke-dasharray": "".concat((_this3.contentBoxWidth + _this3.contentBoxHeight) * 2),
            transition: "stroke-dashoffset ".concat(_this3.showCloseBtnTime, "s, stroke-dasharray ").concat(_this3.showCloseBtnTime, "s"),
            "transition-timing-function": "linear",
            "stroke-dashoffset": "".concat((_this3.contentBoxWidth + _this3.contentBoxHeight) * 2)
          };
          setTimeout(function () {
            _this3.showCloseBtnLater = true;
          }, _this3.showCloseBtnTime * 1000);
        }
      }, 100);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this4 = this;

      EventBus.$on("vip-toast-show", function (data) {
        _this4.toastData = data;
        _this4.isShow = data.show;

        if (data.show) {
          var todayStr = new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getDate();
          var todayZeroTime = new Date(todayStr).getTime(); // 当天0点时间戳

          var time = todayZeroTime + 24 * 60 * 60 * 1000;

          _this4.getCountDown(time);
        }
      });
    }
  }, {
    key: "showCloseBtn",
    get: function get() {
      return this.toastData.showCloseBtn ? this.toastData.showCloseBtn && this.showCloseBtnLater : false;
    }
  }, {
    key: "isChinese",
    get: function get() {
      return getLang().includes('zh');
    }
  }, {
    key: "isGerman",
    get: function get() {
      return getLang() === "de";
    }
  }, {
    key: "isFrench",
    get: function get() {
      return getLang() === "fr";
    }
  }, {
    key: "topImg",
    get: function get() {
      return this.toastData.topImg;
    }
  }, {
    key: "content",
    get: function get() {
      return this.toastData.content;
    }
  }, {
    key: "confirm",
    get: function get() {
      return this.toastData.confirm ? this.toastData.confirm : "";
    }
  }, {
    key: "confirmNotClose",
    get: function get() {
      return this.toastData.confirmNotClose;
    }
  }, {
    key: "confirmFn",
    get: function get() {
      return this.toastData.confirmFn;
    }
  }, {
    key: "cancel",
    get: function get() {
      return this.toastData.cancel;
    }
  }, {
    key: "cancelFn",
    get: function get() {
      return this.toastData.cancelFn;
    }
  }, {
    key: "isFuseAnimate",
    get: function get() {
      return this.toastData.isFuseAnimate;
    }
  }, {
    key: "clickAllBtnOn",
    get: function get() {
      return this.toastData.clickAllBtn;
    }
  }, {
    key: "vipConfirmBtn",
    get: function get() {
      return this.toastData.vipConfirmBtn;
    }
  }, {
    key: "mianContentStyle",
    get: function get() {
      var remainHeight = document.body.clientHeight - this.allHeight;
      return {
        top: remainHeight * this.remainTopRadio + "px"
      };
    }
  }]);

  return VipToast;
}(Vue);

tslib_1.__decorate([Action(types.PAY_BY_IAP)], VipToast.prototype, "payByIap", void 0);

tslib_1.__decorate([Action(types.PAY_VIP)], VipToast.prototype, "payVip", void 0);

VipToast = tslib_1.__decorate([Component({
  components: {
    loadingAnimaton: loadingAnimaton,
    VipBotton: VipBotton
  }
})], VipToast);
export default VipToast;